import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/person/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getCompanyList, getManagementPositionList } from '../../../../helpers/establishment/backend_helper';
import OSelect from '../../../../Components/OElements/OSelect';
import { addNewPerson, getPersonList, importPerson, updatePerson } from '../../../../slices/thunks';

const PersonImportForm = ({ dataPerson, isEdit, handleToggleModalImport, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const selectorPerson = createSelector(
		state => state.Persons,
		result => ({
			isPersonLoading: result.isPersonLoading,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { isPersonLoading, requireCloseModal, } = useSelector(selectorPerson);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			file: null,
		},
		validationSchema: Yup.object({
			file: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async (values) => {
			const formData = new FormData();
			formData.append('file', values.file); // Asegúrate de que values.file es un File válido
			try {
				await dispatch(importPerson(formData)); // Enviar formData correctamente
			} catch (error) {
				console.error("Error en la importación:", error);
			}
			dispatch(setRequireCloseModal(false));
			handleToggleModalImport();
			dispatch(getPersonList());
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModalImport();
			}
		}
	}, [requireCloseModal]);


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<Label for="file">
							Excel - Listado de Personas
						</Label>
						<Input
							id="file"
							name="file"
							type="file"
							accept='.xlsx'
							onChange={(e) => {
								const file = e.currentTarget.files[0];
								validation.setFieldValue("file", file || '');
							}}
							onBlur={validation.handleBlur}
							invalid={
								validation.touched.file &&
									validation.errors.file ?
									true : false
							}
						/>
						{
							validation.touched.file &&
								validation.errors.file ? (
								<FormFeedback type='invalid'>
									{validation.errors.file}
								</FormFeedback>
							) : null
						}
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModalImport();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isPersonLoading}>
						{isPersonLoading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						Importar Personas
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PersonImportForm;
